module.exports = __webpack_public_path__ + "img/car-white.e4837856.png";